class SmsManagementApi {
    constructor(DoclrHttp, praktijkContext, userContext) {
        'ngInject';

        this.praktijkContext = praktijkContext;
        this.userContext = userContext;
        this.DoclrHttp = DoclrHttp;
        this.endpoint = `/apiv0/party/${this.praktijkContext.id}/smsmanagement`;
    }

    getSmsManagement() {
        return this.DoclrHttp.get(this.endpoint);
    }

    updateSmsManagement(smsManagement) {
        return this.DoclrHttp.post(this.endpoint, smsManagement);
    }
}

(function () {
    'use strict';
    angular.module('doclr.instellingen')
        .service('SmsManagementApi', SmsManagementApi)
})();